
import i18n from "@/i18n";
import { profileComputed } from "@/state/helpers";
import { authComputed } from "@/state/helpers";

import { defineComponent } from "vue";
declare interface ComponentData {
  headerText1: string;
  headerText2: string;
  logoImage: string;
}

export default defineComponent({
  data(): ComponentData {
    return {
      headerText1: "Real Estate with",
      headerText2: "KEEPING CURRENT MATTERS",
      logoImage: "",
    };
  },
  methods: {
    changeLanguage(newLanguage: string): void {
      i18n.locale = newLanguage;
      const path =
        "/" + i18n.locale + this.$router.currentRoute.path.substring(3);
      const query = this.$route.query;
      this.$router.push({
        path: path,
        query: query,
      });
    },

    checkLanguage(currentLanguage: string): boolean {
      return i18n.locale === currentLanguage;
    },

    checkGuide(guide: string): boolean | undefined {
      if (
        this.profilePP &&
        this.profilePP.blog &&
        this.profilePP.blog.enabled_pages &&
        this.profilePP.blog.enabled_pages.value
      ) {
        try {
          return JSON.parse(this.profilePP.blog.enabled_pages.value)[guide];
        } catch {
          return false;
        }
      }
      return { buyer: true, seller: true, fthb: false }[guide];
    },

    guideLink(guide: string): string {
      let link = "/" + i18n.locale + "/" + guide + "/";
      if (this.ppCode) {
        link = link + "?a=" + this.ppCode;
      }
      return link;
    },
  },

  computed: {
    ...profileComputed,
    ...authComputed,

    checkLC(): boolean {
      return (
        this.profilePP &&
        this.profilePP.blog &&
        this.profilePP.blog.lead_capture &&
        this.profilePP.blog.lead_capture.value &&
        this.profilePP.blog.lead_capture.value === "on"
      );
    },

    checkMemberLogo(): boolean {
      return (
        this.profilePP &&
        this.profilePP.blog &&
        this.profilePP.blog.logo_pos &&
        this.profilePP.blog.logo_pos.value &&
        this.profilePP.blog.logo_pos.value === "1"
      );
    },

    determineText1(): string {
      if (
        this.profilePP &&
        this.profilePP.blog &&
        this.profilePP.blog.headertext &&
        this.profilePP.blog.headertext.value
      ) {
        return this.profilePP.blog.headertext.value;
      }
      return this.headerText1;
    },

    determineText2(): string {
      if (
        this.profilePP &&
        this.profilePP.blog &&
        this.profilePP.blog.pos_A &&
        this.profilePP.blog.pos_A.value
      ) {
        return this.profilePP.blog.pos_A.value;
      }
      return this.headerText2;
    },

    homeLink(): string {
      let link = "/" + i18n.locale + "/";
      if (this.ppCode) {
        link = link + "?a=" + this.ppCode;
      }
      return link;
    },

    videosLink(): string {
      let link = "/en/videos";
      if (this.ppCode) {
        link = link + "/?a=" + this.ppCode;
      }
      return link;
    },
  },

  mounted(): void {
    if (this.profilePP) {
      this.logoImage = this.profilePP.basic.logo.value;
    }
  },

  watch: {
    profilePP: {
      handler(): void {
        this.logoImage = this.profilePP.basic.logo.value;
      },
      deep: true,
    },
  },
});
